import styled from "styled-components";

export const MyCashBanner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: auto;
  height: 75px;
  padding: 16px 24px;
  border-radius: 10px;
  position: relative;
  background: linear-gradient(
    90deg,
    #ffffff 7.13%,
    #fff2af 27.04%,
    #ffdcce 68.13%,
    #ffffff 92.23%
  );
`;

export const IconContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 98px;
  background-color: white;
  border-radius: 50%;
`;

export const ShieldIcon = styled.div<{ iconUrl: string }>`
  width: 100px;
  height: 100px;
  background-image: url(${(props) => props.iconUrl});
  background-size: cover;
  background-position: center;
`;

export const CurrencySymbol = styled.div`
  position: absolute;
  font-size: 24px;
  font-weight: bold;
  color: black;
`;

export const TextContainer = styled.div`
  display: flex;
  align-items: center;
  margin-left: 16px;
  width: 212px;
`;

export const GradientText = styled.h2`
  font-size: 20px;
  font-weight: bold;
  margin-right: 8px;
  background: linear-gradient(90deg, #573e83, #ac6700);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

export const TooltipContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

export const InfoIcon = styled.div<{ src: string }>`
  width: 20px;
  height: 20px;
  background-image: url(${(props) => props.src});
  background-size: cover;
  background-position: center;
  cursor: pointer;
`;

export const TooltipText = styled.div`
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  width: 218px;
  height: 56px;
  padding: 8px;
  background-color: black;
  color: white;
  font-size: 12px;
  border-radius: 6px;
  opacity: 0;
  transition: opacity 0.3s;

  ${TooltipContainer}:hover & {
    opacity: 1;
  }
`;
